import { CheckCircleFilled, ExclamationCircleFilled } from "@ant-design/icons"
import { Form } from "antd"
import React, { useRef, useState } from "react"
// import upload from "./upload.svg"
import upload from "../../assets/images/upload.svg"
// import useNotify from "src/hooks/useNotify"
// import { addOrgDocs, getPresignedOrgDocs } from "src/apis/signup"
// import { showLoader } from "src/store/states/isLoading"
import { useSetRecoilState } from "recoil"
import { addOrgDocs, getPresignedURLOrg } from "../../services/httpCalls"
import { showloader } from "../../store/gloabalState"
import useNotify from "../../utils/useNotify"
import { checkFileExtension } from "../../utils/check-file-extension"

const EEFCFileupload = ({
  name,
  type,
  isUploaded,
  uploadedList,
  setRefreshEEFC,
  refreshEEFC,
  mode
}) => {
  const [selectedFile, setSelectedFile] = useState(null)
  const [fileName, setFileName] = useState("")

  const [errorMessage, setErrorMessage] = useState("")
  const setShowLoader = useSetRecoilState(showloader)
  const inputRef = useRef()
  const notify = useNotify()
  const uploadFileToS3 = (url, file) => {
    return fetch(url, {
      method: "PUT",
      body: file,
      headers: { "Content-Type": file.type }
    })
  }

  const resetFile = () => {
    // setErrorMessage('')
    setFileName("")
    setSelectedFile(null)
    inputRef.current.value = null
  }
  const handleEffcFileUpload = async (files, filename) => {
    let preSignedUrl
    if (files?.length) {
      setShowLoader(true)
      let orgId = localStorage.getItem("orgId")
      await getPresignedURLOrg(orgId, files[0]?.name)
        .then(async res => {
          preSignedUrl = res.preSignedUrl.split("?")[0]
          await uploadFileToS3(res.preSignedUrl, files[0])
            .then(async () => {
              let OrgData = {
                organisationFileMetaList: [
                  {
                    documentType: "EEFC_BANK_ACCOUNT_STATEMENT",
                    url: preSignedUrl
                  }
                ]
              }
              await addOrgDocs(OrgData, orgId)
                .then(res => {
                  notify.success("EFFC STATEMENT UPLOADED")
                  setErrorMessage("")
                  setRefreshEEFC(!refreshEEFC)
                })
                .catch(err => {
                  notify.error("Error while uploading!")
                })
                .finally(() => { })
            })
            .catch(err => {
              notify.error("Error while uploading to S3")
              resetFile()
            })
            .finally(() => setShowLoader(false))
        })
        .catch(err => {
          notify.error("Error genrating Presigned URL")
          resetFile()
        })
        .finally(() => setShowLoader(false))
    }
  }
  const validFileSize = (size, name) => {
    if (size * 0.001 >= 1024 * 10) {
      notify.error("File size is more than 10MB!")
      setErrorMessage("Please upload file with size less than 10MB")
      resetFile()
      return false
    }
    return true
  }
  function hasSpecialCharacters(filename) {
    const regex = /[`!@#$%^&*()_+\-=\[\]{};':"\\|,<>\/?~]/
    return regex.test(filename)
  }
  const handleFileSelect = e => {
    if (e.target.files?.length) {
      if(!checkFileExtension(e.target?.files[0]?.name)){
        notify.error("Please upload a file with proper extension!");
        resetFile();
      }
      if (!hasSpecialCharacters(e.target?.files[0]?.name)) {
        let sizeofFile = e.target.files[0]?.size
        if (validFileSize(sizeofFile, e.target.name)) {
          setSelectedFile(e?.target?.files?.[0])
          setFileName(e?.target.files[0]?.name)
          handleEffcFileUpload(e.target.files, e.target.name)
        }
      } else {
        setErrorMessage(
          "Please remove special characters from file name such as [,(),#,!,@,~,&,$,%,*,/,|,?,<,} and re-upload eg. XYZ.pdf or xyz123 file.pdf"
        )
        resetFile()
      }
    } else {
      notify.error("No file Selected!")
      resetFile()
    }
  }
  return (
    <Form.Item
      labelCol={{ span: 16, offset: 0 }}
      label={
        <>
          {
            <div style={{ display: "flex", alignItems: "center" }}>
              <span
                style={{
                  fontWeight: "500",
                  fontSize: ".9rem",
                  letterSpacing: ".5px",
                  marginRight: "2px"
                }}
              >
                {type}
              </span>
              {isUploaded ? (
                <>
                  <CheckCircleFilled
                    style={{
                      color: "green",
                      fontSize: "16px",
                      marginLeft: ".5rem"
                    }}
                  />
                </>
              ) : (
                <ExclamationCircleFilled
                  style={{
                    color: "red",
                    fontSize: "16px"
                  }}
                />
              )}
            </div>
          }
        </>
      }
      required
      name={name}
      rules={[
        {
          required: isUploaded ? false : true,
          message: "please upload EEFC account statement"
        }
      ]}
      tooltip="Please upload statement not more than 6 months old"
    >
      <div style={{ margin: "0.5rem 0" }}>
        <div
          className={`${errorMessage
            ? "border-error"
            : isUploaded
              ? "border-uploaded"
              : "border"
            }`}
        >
          <div className="file-upload">
            <img src={upload} alt="" />
            <h4 className="filename_text">
              {" "}
              {fileName
                ? fileName
                : uploadedList[name]
                  ? uploadedList[name]
                  : "No file selected!"}
            </h4>
            <input type="file" onChange={handleFileSelect} ref={inputRef} disabled={mode === "view" ? true : false} />
            <div />
          </div>
        </div>
        <p className="error_message">{errorMessage ? errorMessage : ""}</p>
      </div>
    </Form.Item>
  )
}

export default EEFCFileupload
